module.exports = __webpack_public_path__ + "img/2.0a5c4e8f.jpg";